<template>
  <div :style="{ 'direction': $vs.rtl ? 'rtl' : 'ltr' }">
    <feather-icon v-if="params.data.id" icon="EyeIcon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="ViewRecord" />
  </div>
</template>

<script>
import moduleBankList from '@/store/bank/moduleDataList.js'
import moment from 'moment'
export default {
  name: 'CellRendererActions',
  methods: {
    ViewRecord() {
      if (this.params.data.idoperation) {
        this.$router.push("/outlay/" + this.params.data.idoperation).catch(() => { })
      }
    },
  }
}
</script>
